/* unplugin-vue-components disabled */import { render } from "./mapdata.vue?vue&type=template&id=00225d26&scoped=true"
import script from "./mapdata.vue?vue&type=script&lang=js"
export * from "./mapdata.vue?vue&type=script&lang=js"

import "./mapdata.vue?vue&type=style&index=0&id=00225d26&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00225d26"]])

export default __exports__